export default __webpack_public_path__ + "static/media/24t.a9dcb12e.jpg";